import type { App } from 'vue'
import { inject } from 'vue'

const key = 'app.plugin.fouanalytics.enabled'

export type FouanalyticsConfig = {
    enabled: boolean
}

export function provideFouanalyticsConfig(
    app: App,
    config: FouanalyticsConfig
): void {
    app.provide(key, config)
}

export function useFouanalyticsConfig(): FouanalyticsConfig {
    return inject(key) as FouanalyticsConfig
}
